import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from '@lib/modules';
import { TColumn, TColumnSort } from '@lib/modules/table/components';
import { IListResponse, Nullable } from '@lib/interfaces';
import { CustomersBeneficiaryService } from '@lib/services/customers/customers-beneficiary.service';
import { BaseComponent } from '@lib/components';

@Component({
  selector: 'app-tab-bank-transfer',
  standalone: true,
  imports: [CommonModule,TableModule],
  templateUrl: './tab-bank-transfer.component.html',
  styleUrls: ['./tab-bank-transfer.component.scss']
})
export class TabBankTransferComponent extends BaseComponent implements OnInit {

  @Input() customerId = '';
  public bankTransferList: Array<any> = [];
  public bankTransferListLoading = false;
  public hasMoreRecords = false;
  protected columns: Array<TColumn> = [
    'name',
    'email',
    'phone',
    'nickname',
    'bank',
    'bank_branch_id',
    'bank_id',
    'form_of_payment',
    'country',
    'category',
    'category_display_name',
    'subcategory',
    'subcategory_display_name',
    'instrument_currency',
    'instrument_type',
    'instrument_value',
    'relationship',
    'source_of_funds',
    'is_deleted',
    'status',
    'created'
  ];
  protected defaultColumns: Array<string> = ['name', 'email', 'phone', 'status', 'created'];
  protected sortableColumns: Array<string> = ['created'];

  constructor(private customerBeneficiaryService:CustomersBeneficiaryService){
    super();
  }
  private fetchBankTransfers(limit = 10): void {
    this.addSubscription(
        this.customerBeneficiaryService.getBeneficiaryDetails(this.customerId,'Bank_Transfer').subscribe({
            next: (aliasListResponse: IListResponse<any>): void => {
                this.hasMoreRecords = aliasListResponse.has_more;
                this.bankTransferList = [...aliasListResponse.data];
                this.bankTransferListLoading = false;
            },
            error: (): void => {
                this.bankTransferListLoading = false;
            },
        }),
    );
  }

  ngOnInit(): void {
    this.bankTransferListLoading = true;
    this.fetchBankTransfers(10);
  }

}
